document.addEventListener('alpine:init', () => {
  Alpine.store('currency', {
    shouldApplyMoneyFormat: Shopify.currency.moneyFormat && (
      Shopify.currency.moneyFormat.includes('{{amount}}') || Shopify.currency.moneyFormat.includes('{{amount_with_comma_separator}}')
    ),
    convertLocal(amount) {
      if (Shopify.currency == 'USD') { // No need to convert
        return amount;
      }
      return amount * Shopify.currency.rate;
    },
    formatMoney(amount) {
      const amountText = Number(amount).toFixed(2);
      if (!this.shouldApplyMoneyFormat) {
        return '$'+amountText;
      }
      return Shopify.currency.moneyFormat
        .replace('{{amount}}', amountText)
        .replace('{{amount_with_comma_separator}}', amountText);
    },
    formatCartMoney(amount) {
      return this.formatMoney(amount / 100);
    }
  });

  Alpine.store('cart', {
    cartItems: [],
    isSideCartOpen: false,
    hasMembershipProduct: false,
    shouldApplyMembershipDiscount: false,
    memberSaving: null,
    hasFreeProduct: false,
    hasFixedPriceOffer: false,
    hasAbsoluteFreeProduct: false,
    cartBundleItems: [],
    hasBundleItem: false,
    cartHasLoaded: false,
    lastItemIndex: -1,
    recentlyAddedItem: null,
    tempItems: [],
    dodLimit1Product: false,
    isCartInProgress: false,
    isCartQtyInProgress: false,
    showStickyCheckout: false,
    loyaltyPointBalace: 0,
    totalPrice: 0,
    
    // Cart drawer settings
    freeShippingThreshold: 0,
    memberFreeShippingThreshold: 0,
    freeShippingLockedText: '',
    freeShippingUnlockedText: '',
    memberFreeShippingLockedText: '',
    memberFreeShippingUnlockedText: '',
    freeShippingSettings: {},
    loyaltySettings: {},

    isCustomerMember: false,
    showUpdateItemPopup: false,
    showMobileQuickAddPopup: false,
    editItemDetails: null,
    wishlistItems: {},
    wishlistItemsLoaded: false,

    get wishlistCount() {
      return this.wishlistItemsLoaded ? Object.keys(this.wishlistItems).length : 0;
    },

    get isFreeShippingUnlocked() {
      return this.totalPrice >= this.currentFreeShippingThreshold;
    },

    // Get current free shipping threshold
    get currentFreeShippingThreshold() {
      return this.isCustomerMember || this.hasMembershipProduct ? this.memberFreeShippingThreshold : this.freeShippingThreshold;
    },

    // Calculate free shipping percentage
    get freeShippingPercent() {
      return (this.totalPrice / this.currentFreeShippingThreshold) * 100;
    },

    // Compute free shipping message
    get freeShippingMessage() {
      if (this.isFreeShippingUnlocked) {
        return this.isCustomerMember || this.hasMembershipProduct
          ? this.memberFreeShippingUnlockedText
          : this.freeShippingUnlockedText;
      }
      const freeShippingAway = (this.currentFreeShippingThreshold - this.totalPrice).toFixed(2);
      const lockedText = this.isCustomerMember || this.hasMembershipProduct
        ? this.memberFreeShippingLockedText
        : this.freeShippingLockedText;
      return !lockedText ? '' : lockedText.replace('[#]', Alpine.store('currency').formatMoney(freeShippingAway));
    },

    init() {
      try {

        // Initially load directly from liquid for faster load
        const cartJSONElement = document.querySelector('#store--cart_json[type="application/json"]');
        if (cartJSONElement) {
          const cartDetails = JSON.parse(cartJSONElement.textContent);
          this.loadItems(cartDetails);
        } else {
          this.loadItems();
        }

        if (window.__LIF__.customer_info && window.__LIF__.customer_info.email) {
          this.loadCustomerLoyaltyPoint();
        }

        const { convertLocal } = Alpine.store('currency');

        setTimeout(() => {
          const cartSettingsElement = document.querySelector('#store--cart_settings_json[type="application/json"]');
          // console.log(freeShippingSettingsElement.textContent);
          if (cartSettingsElement) {
            this.freeShippingSettings = JSON.parse(cartSettingsElement.textContent);
          }

          const freeShippingSettingsElement = document.querySelector('#store--cart_free_hipping_settings_json[type="application/json"]');
          // console.log(freeShippingSettingsElement.textContent);
          if (freeShippingSettingsElement) {
            // console.log('Free Shipping Settings Loaded');
            const freeShippingSettings = JSON.parse(freeShippingSettingsElement.textContent);
            
            this.freeShippingThreshold = convertLocal(parseFloat(freeShippingSettings.free_shipping_threshold));
            this.memberFreeShippingThreshold = convertLocal(parseFloat(freeShippingSettings.member_free_shipping_threshold));
            this.freeShippingLockedText = freeShippingSettings.free_shipping_locked_text;
            this.freeShippingUnlockedText = freeShippingSettings.free_shipping_unlocked_text;
            this.memberFreeShippingLockedText = freeShippingSettings.member_free_shipping_locked_text;
            this.memberFreeShippingUnlockedText = freeShippingSettings.member_free_shipping_unlocked_text;
            this.loyaltySettings = freeShippingSettings;
          }
          
        }, 1000); // let's load content

        this.isCustomerMember = window.__LIF__.customer_info && window.__LIF__.customer_info.is_customer_member;

        // Fetch and Store Wishlist Items
        this.fetchWishlistItems();

        this.cartWishlistInitilize();

      } catch(error) {
        console.error(error);
        this.loadItems();
      };

      this.initCheckoutStickyObserver()
    },

    async loadCustomerLoyaltyPoint() {
      const response = await fetch('https://cron.loveinfaith.work/store-backend-staging/customer/getCustomerLoyalty?customer_email='+window.__LIF__.customer_info.email);
      const customerLoyaltyData = await response.json();

      if (customerLoyaltyData && customerLoyaltyData.loyaltyCustomer && customerLoyaltyData.loyaltyCustomer.points) {
        this.loyaltyPointBalace = customerLoyaltyData.loyaltyCustomer.points.balance;
      }
    },

    async loadItems(cartDetails = null) {
      this.isLoading = true;
      try {
        let cartData = null;

        if (cartDetails) {
          cartData = cartDetails;
        } else {
          // const response = await fetch('/cart?view=json&preview_theme_id='+window.Shopify.theme.id);
          const response = await fetch('/cart?view=json');
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          cartData = await response.json();
        }

        if (!cartData.items) {
          console.log('this.cartItems Error. Please find response below ');
          console.log(cartData);
          return;
        }

        for(let i = 0; i < cartData.items.length; i++) {
          // Decode incase of special char encoded
          cartData.items[i].product_title = decodeURIComponent(cartData.items[i].product_title).replaceAll('+', ' ');
        }
        
        this.cartItems = cartData.items;
        this.totalPrice = (cartData.total_price / 100).toFixed(2);
        this.originalTotalPrice = (cartData.original_total_price / 100).toFixed(2);


        // this.totalDiscount = (cartData.total_discount / 100).toFixed(2);
        
        // Calculate based on compare_at_price
        const totalDiscount = cartData.items.reduce((total, item) => {
          
          // Skip winter product
          if (item.properties.attributes && item.properties.attributes.__is_winter_product) {
            return total;
          }

          const comparePrice = Number(item.compare_at_price);
          const quantity = Number(item.quantity || 1);
          const finalPrice = Number(item.final_line_price);

          return total + ((comparePrice * quantity) - finalPrice);
        }, 0);

        this.totalDiscount = (totalDiscount / 100).toFixed(2);
        

        // this.totalDiscount = (cartData.total_discount / 100).toFixed(2);

        this.hasMembershipProduct = !!this.cartItems.find((item) => item.product_type.includes('Membership'));
        this.hasFreeProduct = !!this.cartItems.find((item) => item.properties.attributes && item.properties.attributes._is_free_shirt);
        this.cartBundleItems = this.cartItems.reverse().filter((item) => item.properties.attributes && item.properties.attributes.__winter_bundle_sale);
        this.hasBundleItem = this.cartItems.find((item) => item.properties.attributes && item.properties.attributes.__is_winter_product);

        this.shouldApplyMembershipDiscount = this.hasMembershipProduct || (window.__LIF__.customer_info && window.__LIF__.customer_info.is_customer_member);

        // Do not apply Member price for wholesale customer
        if (window.__LIF__.customer_info && window.__LIF__.customer_info.is_b2b) {
          this.shouldApplyMembershipDiscount = false;
        }

        // const maxLineItemIndex = Math.max(...this.cartItems.map(item => item.properties.attributes.__line_item_index))
        const recentlyAddedVariantId = getLifCookie('LIF-PARAMS--recentlyAddedVariantId');
        if (recentlyAddedVariantId) {
          this.recentlyAddedItem = this.cartItems.find((item) => item.variant_id == recentlyAddedVariantId);
        }

        this.dodLimit1Product = this.cartItems.find((item) => item.properties.attributes && item.properties.attributes.__has_dod_limit_1);

        // Calculate member saving
        let savings = 0;
        cartData.items.forEach((item) => {
          const itemProperties = item.properties && item.properties.attributes ? item.properties.attributes : {};

          // console.log('itemProperties: ');
          // console.log(itemProperties);

          if (item.properties.attributes.__fixed_price_offer) {
            this.hasFixedPriceOffer = true;
          }

          if (itemProperties.__member_discount_percentage) { // Old items having this property (Remove in future)
            const memberSavingPercentage = itemProperties.__member_discount_percentage;
            // const compareAtPrice = item.properties.__compare_at_price;
            // const itemPrice = compareAtPrice || item.line_price;
            const itemPrice = item.original_price;

            if (memberSavingPercentage) {
              const discountPrice = itemPrice * parseFloat(memberSavingPercentage) * 0.01;
              if (item.original_line_price == item.line_price) {
                savings += discountPrice * item.quantity;
              } else {
                const offerDiscounted = item.original_line_price - item.line_price;
                if (discountPrice > offerDiscounted) {
                  savings += discountPrice - offerDiscounted;
                }
              }
            }
          } else if (itemProperties.__member_discount_price) { // This is new item property based on Product member price metafield
            const discountPrice = itemProperties.__member_discount_price * 100;

            if (discountPrice) {
              const memberDiscount = item.original_line_price - (discountPrice * item.quantity);

              if (item.original_line_price == item.line_price && memberDiscount > 0) {
                savings += memberDiscount;
              } else {
                const offerDiscounted = item.original_line_price - item.line_price;
                if (memberDiscount > offerDiscounted) {
                  savings += memberDiscount - offerDiscounted;
                }
              }
            }
          }

          if (item.price == 0) {
            this.hasAbsoluteFreeProduct = true;
          }

          if (this.lastItemIndex < itemProperties.__line_item_index) {
            this.lastItemIndex = itemProperties.__line_item_index;
          }
        });
        this.memberSaving =  {
          savings: savings,
          value: (savings / 100).toFixed(2).toString().replace('.00', ''),
          percentage: savings && cartData && cartData.total_price ? ((savings / cartData.total_price) * 100).toFixed(2) : 0,
        };

        if (!this.cartHasLoaded) {
          this.cartHasLoaded = true;

          if (!Alpine.store('sale')) { // Check if sale is loaded
            return;
          }

          // Trigger all event that should run after cart load for first time
          if (Alpine.store('customBundle').offerSwitched) {

            console.log('deactivateOtherOffers for customBundle');
            Alpine.store('customBundle').deactivateOtherOffers();

          } else if (Alpine.store('dynamicSale').offerSwitched) {

            console.log('deactivateOtherOffers for dynamicSale');
            Alpine.store('dynamicSale').deactivateOtherOffers();

          } else if (Alpine.store('offer1Free').offerSwitched) {

            console.log('deactivateOtherOffers for offer1Free');
            Alpine.store('offer1Free').deactivateOtherOffers();

          } else {
            Alpine.store('sale').refreshOffers();
          }
        }

        this.isCartInProgress = false;
      } catch (error) {
        this.isLoading = false;
        console.error('There was a problem with the fetch operation:', error);
      }
      this.isLoading = false;
    },

    async addItems(items, onComplete = null, refreshCart = true, openSideCart = true) {

      const renderElement = window.location.pathname == '/cart' ? 'cart-items' : null; // : 'cart-drawer';
      const cartDrawer = refreshCart && renderElement ? document.querySelector(renderElement) : null;

      // properties.__line_item_index = this.lastItemIndex + 1;
      // const item = { quantity, id: variantId, properties: { attributes: properties } };

      // reset recentlyAddedItem earlier when new item going to add
      this.recentlyAddedItem = null;

      /**
       * Adding additional wrapper of field "attributes"
       * So that we have to fetch only single field on Shopify Function input query
       */
      for (let i = 0; i < items.length; i += 1) {        

        // Check if same variant is aleady existing in cart
        const existingVariant = this.cartItems.length == 0 ? null : this.cartItems.find((c) => c.variant_id == items[i].id)

        let newLineItemIndex = 0;
        if (existingVariant) {
          // Use same property to avoid consider as seperate item
          newLineItemIndex = existingVariant.properties.attributes.__line_item_index;
        } else {
          this.lastItemIndex += 1;
          newLineItemIndex = this.lastItemIndex;
        }

        const itemProperties = items[i].properties;
        itemProperties.__line_item_index = newLineItemIndex;
        items[i].properties = { _attributes: itemProperties };

        if (i == items.length - 1) {
          setLifCookie('LIF-PARAMS--recentlyAddedVariantId', items[i].id, 1);
        }
      }

      if (refreshCart) {
        if (openSideCart) {
          this.isSideCartOpen = true;
        }
        this.isCartInProgress = true;
      }

      const postData = { items };

      // Check if cart drawer is activated
      if (cartDrawer) {
        postData.sections = cartDrawer.getSectionsToRender().map((section) => renderElement == 'cart-drawer' ? section.id : section.section);
      }

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'post',
          body: JSON.stringify(postData),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        });

        if (cartDrawer) {
          if (renderElement == 'cart-drawer') {
            const responseData = await response.json();
            cartDrawer.renderContents(responseData);
            this.isSideCartOpen = true;
          } else {
            const state = await response.text();
            const parsedState = JSON.parse(state);

            cartDrawer.getSectionsToRender().forEach((section) => {
              if (section.id == 'main-cart-items') {
                // console.log('section.section');
                // console.log(section.section);

                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
                elementToReplace.innerHTML = cartDrawer.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              }
            });

            // Let's reload reward point balance
            this.reloadSwellPointElement();
          }
        }
        await this.loadItems(); // Re-load items after adding

        if (refreshCart) {
          setTimeout(() => {
            this.isCartInProgress = false;
          }, 1000);
        }

        if (onComplete) {
          onComplete();
        }
      } catch (error) {
        console.error(error);
      }
    },

    async updateItemProperty(id, properties, refreshCart = true) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id, properties })
      });

      console.log('Update Item Property Response: ');
      console.log(response)

      if (refreshCart) {
        await this.loadItems(); // Re-load items after adding
      }
    },

    async updateItemQuantity(id, quantity) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id, quantity })
      });

      console.log('Update Item Qty Response: ');
      console.log(response)
    },

    async removeMultipleItems(keys) {

      const updates = {};
      for(let i = 0; i < keys.length; i++) {
        updates[keys[i]] = 0
      }

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

      } catch (error) {
        console.error(error);
      }
      
    },

    async removeItem(key, refreshCart = true, isBBEdit = false) {

      console.log('removeItem: '+key);

      const updates = {
        [key]: 0
      };

      if (this.cartItems) {
        const selectedItem = this.cartItems.find((i) => i.key == key);
        if (!selectedItem) {
          console.log('No item exist to delete.');
          this.loadItems();
          return;
        }

        // Check if incremental sale v2 bundle item deleted
        if (selectedItem.properties.attributes 
          && selectedItem.properties.attributes.__incremental_sale 
          && selectedItem.properties.attributes.__incremental_sale.offerCode == 'v2'
          && selectedItem.properties.attributes.__incremental_sale.lineItemIndex < 5) {
          Alpine.store('incrementalSaleV2').deleteBundleItem(key);
          return;
        }

        if (!isBBEdit) {
          // Check if item is bb product
          if (selectedItem.properties.attributes && selectedItem.properties.attributes._bb_upgrade_shirt) {
            const bbKit = this.cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_kit);

            // Delete BBKit too
            if (bbKit) {
              updates[bbKit.key] = 0;
            }
          }

          // Check if item is bb kit
          if (selectedItem.properties.attributes && selectedItem.properties.attributes._bb_upgrade_kit) {
            const bbShirt = this.cartItems.find((i) => i.properties.attributes && i.properties.attributes._bb_upgrade_shirt);

            // Delete BBShirt too
            if (bbShirt) {
              updates[bbShirt.key] = 0;
            }

            // delete bbShirt.properties.attributes._bb_upgrade_shirt;

            // // Remove bbShirt Property
            // await this.updateItemProperty(bbShirt.key, bbShirt.properties);
          }

          // console.log('selectedItem.properties.attributes: ');
          // console.log(selectedItem.properties.attributes);

          // // Check if item is fwp free product
          if (selectedItem.properties.attributes && selectedItem.properties.attributes._is_free_shirt && selectedItem.properties.attributes._applied_offer_type == 'fwp') {
            const fwpSecondProduct = this.cartItems.find((i) => i.properties.attributes && i.properties.attributes._fwp_second_product);

            // Delete fwpSecondProduct too
            if (fwpSecondProduct) {
              updates[fwpSecondProduct.key] = 0;
            }
          }
        }

        // Check if bundle item is deleting
        if (selectedItem.properties.attributes && selectedItem.properties.attributes.__winter_bundle_sale) {
          // Check if last bundle item is going to delete
          if (this.cartBundleItems.length == 1) {
            // Delete bundle product too if exist
            if (this.hasBundleItem) {
              updates[this.hasBundleItem.key] = 0;
            }
          }
        }
      }

      const renderElement = window.location.pathname == '/cart' ? 'cart-items' : null;
      const cartDrawer = refreshCart && renderElement ? document.querySelector(renderElement) : null;

      this.isCartInProgress = true;
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ 
            updates, 
            sections: cartDrawer ? (cartDrawer.getSectionsToRender().map((section) => renderElement == 'cart-drawer' ? section.id : section.section)) : [], 
          })
        });

        if (refreshCart) {
          this.loadItems();
        }

        if (cartDrawer) {
          this.loadItems();

          // From other than cart page, Re-render sidecart
          if (renderElement == 'cart-drawer') {
            const responseData = await response.json();
            cartDrawer.renderContents(responseData);
            this.isSideCartOpen = true;
          } else {

            // From cart page, Re-render cart page
            const state = await response.text();
            const parsedState = JSON.parse(state);

            cartDrawer.getSectionsToRender().forEach((section) => {
              if (section.id == 'main-cart-items') {
                // console.log('section.section');
                // console.log(section.section);

                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
                elementToReplace.innerHTML = cartDrawer.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              }
            });

            // Let's reload reward point balance
            this.reloadSwellPointElement();
          }
        } else if (refreshCart) {
          await this.loadItems();
          this.isCartInProgress = false;
        }

      } catch (error) {
        this.isCartInProgress = false;
        console.error(error);
      }
    },

    moveToWishlist(key) {
      this.removeItem(key);
      const selectedItem = this.cartItems.find((i) => i.key == key);

      WishlistKing.addWishlistItem({ 
        productHandle: selectedItem.product_handle,
        variantId: selectedItem.variant_id
      });

      setTimeout(() => {
        this.fetchWishlistItems();
      }, 2000);
    },

    removeFromWishlist(key) {
      const selectedItem = this.cartItems.find((i) => i.key == key);
      const wishlistItem = this.wishlistItems[selectedItem.product_id];

      if (wishlistItem) {
        WishlistKing.removeWishlistItem({ wishlistItemId: wishlistItem.id });

        setTimeout(() => {
          this.fetchWishlistItems();
        }, 2000);
      }
    },

    cartWishlistInitilize() {
      
      // This is quivalant of 
      // $(document).on('click', '.wishlist-button', fn);

      document.addEventListener('click', (e) => {

        // Add / Remove wishlist item
        if (e.target.closest('wishlist-button-block .wk-button')) {
          console.log('Wishlist button clicked');

          setTimeout(() => {
            console.log('Fetching latest Wishlist items');
            this.fetchWishlistItems();
          }, 2000); // Let's wait to perform wishlist action
        }

        // Handle item submit button click
        const wishlistFormSubmitButton = e.target.closest('wishlist-product-card form.wk-form button[type="submit"]');

        if (wishlistFormSubmitButton) {

          e.preventDefault(); // stop real submit
          e.stopImmediatePropagation();

          // const form = document.querySelector('wishlist-product-card form.wk-form');
          const form = wishlistFormSubmitButton.closest('form');

          if (!form) return;   // Not our form

          const formData = new FormData(form);
          const formParams = Object.fromEntries(formData);

          // Check if same variant is aleady existing in cart
          const existingVariant = this.cartItems.length == 0 ? null : this.cartItems.find((c) => c.variant_id == formParams.id);

          let newLineItemIndex = 0;
          let memberDiscountPrice = 0;
          if (existingVariant) {
            // Use same property to avoid consider as seperate item
            newLineItemIndex = existingVariant.properties.attributes.__line_item_index;
            memberDiscountPrice = existingVariant.properties.attributes.__member_discount_price;
          } else {
            this.lastItemIndex += 1;
            newLineItemIndex = this.lastItemIndex;
          }

          const item = {
            id: formParams.id,
            quantity: formParams.quantity,
            properties:  {
              __member_discount_price: memberDiscountPrice,
              __line_item_index: newLineItemIndex
            }
          }

          this.addItems([item], () => {
            // Remove item from wishlist
            const cartItem = this.cartItems.find((c) => c.variant_id == formParams.id);
            if (cartItem) {
              this.removeFromWishlist(cartItem.key);
            }
          });

        }
        if (e.target.closest('remove-button') || e.target.closest('wk-button')) {
    
          console.log('Wishlist remove clicked');

          setTimeout(() => {
            this.fetchWishlistItems();
          }, 500);
        }
      });

    //   document.addEventListener('submit', function (e) {
    //     console.log('Submit');

    //     const form = e.target.closest('wishlist-product-card form.wk-form');
    //     console.log(form);

    //     if (!form) return;   // Not our form

    //     e.preventDefault(); // stop real submit
    //     e.stopImmediatePropagation();

    //     // Your submit logic
    //     const formData = new FormData(form);
    //     console.log('Wishlist form submitted', Object.fromEntries(formData));
    // });

    },

    fetchWishlistItems() {

      const url = `https://api.appmate.io/v2/wishlists/mine`;
      const sessionId = window.localStorage.getItem('wk_session_id') || "";
      const options = {
        method: 'GET',
        headers: { 
          'x-appmate-sid': sessionId,
          'x-appmate-shp': window.Shopify.shop
        }
      };

      fetch(url, options)
        .then(response => response.json())
        .then(response => {

          const byVariantId = Object.fromEntries(
            response.wishlist.items.map(({ variantId, productId, id }) => [
              productId,
              { productId, variantId, id }
            ])
          );

          this.wishlistItems = byVariantId;
          this.wishlistItemsLoaded = true;
        });
    },
    
    async removeAndAddItem(deleteItemKey, item, onComplete) {

      console.log('removeItem: '+deleteItemKey);
      const updates = { [deleteItemKey]: 0 };

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ 
            updates, 
          })
        });

        // this.addItems([item], onComplete, true, false);
        await this.addItems([item], onComplete, true, true);

      } catch (error) {
        console.error(error);
      }
      
    },

    reloadSwellPointElement() {
      const swellPoint = document.getElementById('swell_point_balance_storage');
      if (swellPoint) {
        // Let's reload reward point balance
        const swellPointElements = document.querySelectorAll('.swell-point-balance');

        swellPointElements.forEach((e) => {
          e.innerHTML = swellPoint.innerHTML;
        });
      }
    },

    addMemberProduct() {
      if (window.__LIF__ && window.__LIF__.membership_settings && window.__LIF__.membership_settings.membership_product) {
        // console.log('Adding member item...');

        const memberProduct = window.__LIF__.membership_settings.membership_product;
        const item = {
          id: memberProduct.id,
          quantity: 1,
          properties: { __is_member_product: true },
          selling_plan: memberProduct.selling_plan_id,
        }

        this.addItems([item]);
      }
    },
  
    removeMemberProduct() {
      // console.log('Removing member item...');
      if (!window.__LIF__ || !window.__LIF__.membership_settings || !window.__LIF__.membership_settings.membership_product) {
        return false;
      }
  
      // console.log('removeMemberProduct');
      const memberLineItem = this.cartItems.find((i) => i.variant_id == window.__LIF__.membership_settings.membership_product.id);
      // console.log(memberLineItem);
  
      if (memberLineItem) {
        this.removeItem(memberLineItem.key);
      }
    },

    get metFreeProductThreshold() {
      // Don't apply threshold on winback-free-shirt
      if (getLifCookie('LIF-PARAMS--FREE_SHIRT_OFFER') === 'winback-free-shirt') {
        return true;
      }

      // Check if free product type in cart
      const freeProducts = this.cartItems.filter((i) => i.product_type.toLowerCase().startsWith('free:'))
      if (freeProducts.length == 0 
        && !this.hasAbsoluteFreeProduct 
        && !this.hasFreeProduct 
        && !this.hasFixedPriceOffer) {
        return true;
      }

      let itemsSubtotal = 0;

      for (let i = 0; i < this.cartItems.length; i++) {
        const productType = this.cartItems[i].product_type.toLowerCase();
        // Exempt Clearance and Mystery products from being counted towards “Free:” product threshold
        if (
          !productType.includes('clearance') &&
          !productType.includes('mystery') &&
          !(productType === 'gift card') &&
          !productType.startsWith('Free:')
        ) {
          itemsSubtotal += parseFloat(this.cartItems[i].final_line_price);
        }
      }

      console.log(`Free Product Threshold - Items Sub Total: ${itemsSubtotal}`);

      const fpthreshold = this.hasFixedPriceOffer ? window.__LIF__.offer_fixed_price_settings.price_threshold : window.__LIF__.free_product_threshold;
      // if (this.hasFreeProduct) {
      //   fpthreshold = window.__BVA__.feature_free_product.free_product_threshold;
      // } else if (this.hasFreeShirtInCart) {
      //   // send to our members, and we are okay with them checking out with only the free product
      //   if (getCookie('LIF-PARAMS--FREE_SHIRT_OFFER') === '1freemember') {
      //     return true;
      //   }
      //   fpthreshold = window.__BVA__.feature_free_product.free_shirt_offer_threshold;
      // }

      const { convertLocal } = Alpine.store('currency');
      const freeShippingThreshold = convertLocal(parseFloat(fpthreshold));
      return parseFloat(itemsSubtotal) / 100 >= freeShippingThreshold;
    },

    get hasOverSoldProduct() {
      return !!this.cartItems.find((i) => i.properties.attributes.__is_oversold_product)
    },

    get hasBBKitProduct() {
      return !!this.cartItems.find((i) => i.properties.attributes._bb_upgrade_kit)
    },

    get cartItemsCount() {
      // If the product type = “Bundle Deal” then don’t include it in the count of products in cart drawer
      return this.cartItems
        .filter((item) => item.product_type != 'Bundle Deal')
        .reduce((total, item) => total + Number(item.quantity || 0), 0);
    },

    get hideMemberWidget() {
      return this.shouldApplyMembershipDiscount || Alpine.store('sale').hideMemberWidget;
    },

    async clearCart() {
      try {
        await fetch('/cart/clear.js', { method: 'POST'});
      } catch (error) {
        console.error(error);
      }
    },

    pushTempItemsToCart(needRefreshCart) {
      console.log('---------- pushTempItemsToCart: ------------');
      const items = [];
      
      for (let i = 0; i < this.tempItems.length; i += 1) {
        const { variant_id, properties, quantity, selling_plan } = this.tempItems[i];

        const cartItem = { id: variant_id, properties: properties.attributes, quantity };

        if (selling_plan && selling_plan.id) {
          cartItem.selling_plan = selling_plan.id;
        }

        items.push(cartItem);
      }

      if (items.length > 0) {
        this.addItems(items, null, false);
      } else if (needRefreshCart) {
        // refresh cart
        this.loadItems();
      }
    },

    gotoCheckout() {
      // Check if cart has free product
      if (this.hasFreeProduct) {

        // Set cookie to indicate that offer 1 free is already used
        // This is not required for EVE theme
        /*
        if (window.__LIF__.offer_1_free_settings && window.__LIF__.offer_1_free_settings.end_time) {
          const offerEndDateTime = new Date(window.__LIF__.offer_1_free_settings.end_time);
          setLifCookieByExpiryDate('LIF-PARAMS-free_offer_has_been_used', '1', offerEndDateTime);
        } else {
          setLifCookie('LIF-PARAMS-free_offer_has_been_used', "1", 365); // used 365 days for parmanent cookie storage
        }
        */

        // Delete offer 1 free cookie
        removeLifCookie(lifOfferKeyUsed.offer1Free.cookieKeysUsed[0]);
      }

      setTimeout(() => {
        window.location.href = '/checkout';
      }, 500);
    },

    initCheckoutStickyObserver() {  
      window.addEventListener('DOMContentLoaded', () => {
        const target = document.getElementById('cart__active_checkout_button');
        if (target) {
          const options = {
            rootMargin: '-150px 0px 0px 0px'
          }

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.showStickyCheckout = !entry.isIntersecting;
            });
          }, options);

          observer.observe(target);
        }
      });
    },

    closeCart() {
      // Check if black friday sale active
      const { isActive: isActiveBlackFridaySale, saleDetails: blackFridaySaleDetails, activeOffer } = Alpine.store('blackFridaySale');
      const { incrementalSaleActive } = Alpine.store('sale');
      const { baseURL } = Alpine.store('URL');

      if (isActiveBlackFridaySale) {

        const offerCollection = activeOffer ? '/collections/'+activeOffer.offer_collection : '';

        // Check if sale target collection
        if (blackFridaySaleDetails.originalTargetCollection != baseURL && window.location.pathname != offerCollection) {
          window.location.href = blackFridaySaleDetails.originalTargetCollection;
        } else {
          Alpine.store('cart').isSideCartOpen = false;
        }
      } else if (incrementalSaleActive) {
        const { saleDetails } = Alpine.store('incrementalSale');

        // Check if sale target collection
        if (saleDetails.targetCollection != baseURL) {
          window.location.href = saleDetails.targetCollection;
        } else {
          Alpine.store('cart').isSideCartOpen = false;
        }
        
      } else {
        Alpine.store('cart').isSideCartOpen = false;
      }
    },
    compareAtPriceText(item) {
      return Alpine.store('currency').formatCartMoney(item.compare_at_price * item.quantity);
    }
  });

  // using collection next page as global because this is resetting when filter apply
  Alpine.store('collection', {
    hasNextPage: true,
    additionalQueryString: null,
    firstProductSettings: null,
    reloadTrigger: 1,

    async loadFirstProduct() {
      if (this.firstProductSettings && this.firstProductSettings.targetCollection == window.location.pathname) {
        console.log('Fetching product card...');

        try {

          // Collect paramter by split by commna and clean
          const productParamsAll = this.firstProductSettings.productId
            .split(',')
            .map(i => i.trim())
            .filter(i => i);

          // Make unique params
          const productParams = [...new Set(productParamsAll)];
          const productIds = [];
          let productHandles = [];

          // Collect product handles if id is passed
          for(let i = 0; i < productParams.length; i++) {
            if (!isNaN(Number(productParams[i]))) {
              productIds.push(productParams[i]);
            }
          }

          if (productIds.length > 0) {
            const res = await fetch(`https://cron.loveinfaith.work/store-backend/product/handlesByIds?ids=${productIds}`);
            const response = await res.json();
            const products = response.data;

            for(let i = 0; i < productParams.length; i++) {
              if (productIds.includes(productParams[i])) {
                const productDetails = products.find(p => p.id == productParams[i]);
                if (productDetails) {
                  productHandles.push(productDetails.handle);
                }
              } else {
                productHandles.push(productParams[i]);
              }
            }

          } else {
            productHandles = productParams;
          }

          console.log('productHandles: ');
          console.log(productHandles);

          // Make unique handle
          const finalProductHandles = [...new Set(productHandles)];
          finalProductHandles.forEach((productId, index) => this.renderProductCardByHandle(productId, index));
        } catch(error) {
          console.error(error);
        }
      }
    },
    async renderProductCardByHandle(handle, index) {
      const productGridContainer = document.getElementById('product_grid');

      // Fetch again to get exact same details as other products have to maintain consistency
      fetch(`https://www.loveinfaith.life/products/${handle}?view=card`)
      .then(resp => resp.text())
      .then(productCardHtml => {
        if (!productCardHtml.includes('404 Page Not Found')) {
          const contentHtml = `<li style="order: ${-99999+index+1}" x-cloak class="product-card-always-on-top list-none" :class="{ hidden: !$store.collection.firstProductSettings }">${productCardHtml}</li>`
          productGridContainer.insertAdjacentHTML('afterbegin', contentHtml);
        }
      });
    },
    isProductRenderedAsFirst(productHandle, productId) {
      if (!this.firstProductSettings || this.firstProductSettings.targetCollection != window.location.pathname) {
        return false;
      }

      const productHandles = this.firstProductSettings.productId.split(',');

      if (productHandles.includes(productHandle) || productHandles.includes(productId)) {
        return true;
      }

      return false;
    }
  });

  Alpine.store('pdp', {
    disabledATC: false,
    disabledEditATC: false,
  });

  Alpine.store('screen', {
    isMobile: window.innerWidth <= 480,
    isScrollableBody: true,
    
    init() {
      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth <= 480;
      });
    },
    get isAndroidEdge() {
        const ua = navigator.userAgent;
        return /Android/i.test(ua) && /EdgA/i.test(ua);
    }
  });

  Alpine.store('css', {
    bgColor(color) {
      return color ? `--bg-color:${color};` : '';
    },
    bgImage(image) {
      return image ? `--bg-image:${image};` : '';
    },
    borderColor(image) {
      return image ? `--br-color:${image};` : '';
    },
    borderImage(image) {
      return image ? `--br-image:${image};border-image-slice: 1;` : '';
    },
    fontColor(color) {
      return `--font-color:${color};`;
    }
  });

  Alpine.store('class', {
    bgColor: 'bg-[color:--bg-color]',
    bgImage: 'bg-[image:--bg-image]',
    borderColor: 'border-[color:--br-color]',
    borderImage: '[border-image:--br-image]',
    fontColor: 'text-[color:--font-color]',
  })
});
